// React Components

// Material UI Components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Displays the single tenant associated with the company.
export default function TenantDropDown(props){

    const { company, selectedTenantOption } = props;
    const tenant = selectedTenantOption || company?.tenantList?.[0];


    return(


    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            columnGap: 1.5,
            mb: 2.5,
            minWidth: 0,
        }}
    >
        <Typography sx={{ fontWeight: 600, flexShrink: 0 }}>For Tenant:</Typography>
        <Typography sx={{ fontWeight: 600, minWidth: 0, overflowWrap: 'anywhere' }}>{tenant?.tenantUrl ?? '-'}</Typography>
    </Box>
    );
};
